import {Modal} from 'antd'
import {docs_createCodiLink_Api, docs_deleteCodiLink_Api, docs_editCodiLink_Api, docs_getCodiLinks_Api,} from 'apis'
import {getType} from 'apis/model/base'
import classNames from 'classnames'
import {LoginContext} from 'components/LoginContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BsPencilSquare, BsTrash} from 'react-icons/bs'
import {IoIosAddCircleOutline} from 'react-icons/io'
import {RiCircleFill} from 'react-icons/ri'
import {Link, useLocation} from 'react-router-dom'
import CodiDocumentContext from 'views/Document/CodiDocumentContext'
import CodiCreateLink, {CodiEditLink,} from 'views/Document/EditForms/CodiCreateLink'
import EntityList from 'views/AppLocals/EntityList'
import {AppEntities} from 'views/AppLocals/enums'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from 'views/AppLocals/factory/createNotification'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault, renderIf} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {CodiSubHeader} from './CodiSiderHeading'
import TooltipApp from "components/TooltipApp";
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const CodiLinkTypes = Object.freeze({
    INSTRUCTION: {
        label: 'guided by',
        title: 'instruction',
        value: 'instruction',
        token: '__instruction_token__',
    },
    REPLACEMENT: {
        label: 'as a replacement for',
        title: 'replacement',
        value: 'replacement',
        token: '__replacement_token__',
    },
    REFERENCE: {
        label: 'referenced by',
        title: 'reference',
        value: 'reference',
        token: '__reference_token__',
    },
    AMENDMENT: {
        label: 'amended by',
        title: 'amendment',
        value: 'amendment',
        token: '__amendment_token__',
    },
})

const getPathDocumentType = (documentType) => {
    const documentTypePath = _.get(documentType, 'title')
    if (!!_.get(documentType, 'parent')) {
        return [
            getPathDocumentType(_.get(documentType, 'parent')),
            documentTypePath,
        ].join(' - ')
    }
    return documentTypePath
}

export const renderCodiLink =
    ({renderContextMenu = NullAsDefault} = {}) =>
        (item, index) => {
            const {link, eff_date} = item || {}

            const link_type = getType(link)

            const document_no = link?.document_no ?? link?.codi_document?.document_no

            const document = _.get(link, 'document')
            const codi_document = _.get(link, 'codi_document')

            const effected_date =
                _.get(item, 'related_type') === 'replacement'
                    ? formatDate(_.get(link, 'eff_date'), 'DD/MM/YYYY')
                    : formatDate(eff_date, 'DD/MM/YYYY')

            let params = {}
            switch (link_type) {
                case AppEntities.CODI_DOCUMENT:
                    params = {
                        title: (
                            <React.Fragment>
                                <span className="font-bold text-primary">{getTitle(link)}</span>
                                <span
                                    className="ml-1 text-xs text-color-400 italic no-underline">{`(${document_no})`}</span>
                            </React.Fragment>
                        ),
                        content: getPathDocumentType(_.get(link, 'document_type')),
                    }
                    break
                case AppEntities.CODI_DOCUMENT_ROW:
                    params = {
                        title: (
                            <React.Fragment>
              <span className="font-bold text-primary">
                {_.get(link, 'codi_document.title')}
                  <span className="ml-1 text-xs text-color-400 italic no-underline">{`(${document_no})`}</span>
              </span>
                            </React.Fragment>
                        ),
                        content: link?.content,
                        short_index_name: link?.short_index_name,
                        index_cd: link.index_cd,
                    }
                    break
                default:
                    break
            }

            return (
                <Translate key={index}>
                    {(t) => (
                        <div className="flex flex-1 items-start gap-2 relative">
                            <div className="flex flex-1 flex-col">
                                <TooltipApp
                                    title={params.title}
                                    color="#fff">
                                    <Link
                                        style={{lineHeight: '1.3', marginRight: '2rem'}}
                                        className="font-semibold text-doc-xs max-lines-1"
                                        target="_blank"
                                        to={getLinkToDetail(_.get(item, 'link'))}>
                                        {params.title}
                                    </Link>
                                </TooltipApp>
                                {params.content ? (
                                    <div className="text-xs italic space-x-1 leading-snug mt-1">
                                        {renderIf(
                                            params.short_index_name,
                                            <span className="font-bold text-color-000">
                      {`${params.short_index_name} : `}
                    </span>
                                        )}
                                        <span className="text-color-300">{params.content}</span>
                                    </div>
                                ) : (
                                    <span className="leading-snug ml-1 mt-1 font-bold text-xs text-color-000 italic">
                  {params.index_cd}
                </span>
                                )}
                                {!!_.get(item, 'children.length') && (
                                    <div
                                        className="flex flex-col ml-2 pl-2 py-1 border-l-2 border-primary background-50 rounded-lg w-full">
                                        {_.get(item, 'children', []).map((e, i) => {
                                            return (
                                                <React.Fragment key={i}>
                                                    {renderCodiLink()(e, i)}
                                                </React.Fragment>
                                            )
                                        })}
                                    </div>
                                )}
                            </div>
                            <div className="absolute right-0">{renderContextMenu(item)}</div>
                        </div>
                    )}
                </Translate>
            )
        }

const CodiLinkBlock = ({
                           title,
                           owner_id,
                           owner_type,
                           related_type,
                           renderItem = NullAsDefault,
                           renderActions = NullAsDefault,
                           token = 'refreshToken',
                       }) => {
    const t = useTranslate()

    const location = useLocation()

    const apiInfo = docs_getCodiLinks_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo?.path
                    ?.replace(':id', owner_id)
                    ?.replace(':type', owner_type)
                    ?.replace(':related_type', related_type),
                `refreshToken=${_.get(location.state, token)}`,
            ].join('/'),
        [token, owner_id, owner_type, related_type, location.state]
    )

    if (_.isEmpty(related_type)) {
        return null
    }

    return (
        <EntityList
            key={refreshKey}
            apiInfo={apiInfo}
            refreshKey={refreshKey}
            query={bindQueryParams([
                {related_type},
                {id: owner_id},
                {type: owner_type},
            ])}
            renderItem={renderItem}
            RenderEntity={React.Fragment}
            renderWrap={(child) => (
                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between uppercase text-sm text-color-300 border-b">
                        <CodiSubHeader
                            title={title}
                            bordered={false}
                        />
                        {renderActions({owner_id, owner_type, related_type})}
                    </div>
                    <div className="space-y-3">{child}</div>
                </div>
            )}
        />
    )
}

const CodiDocumentLinks = ({
                               item,
                               style,
                               target,
                               className,
                               current_row,
                               linkTypes = [
                                   CodiLinkTypes.INSTRUCTION,
                                   CodiLinkTypes.REPLACEMENT,
                                   CodiLinkTypes.REFERENCE,
                               ],
                           }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const login = useContext(LoginContext) || {}

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const params = {
        owner_id: target?.id,
        owner_type: getType(target),
    }

    const getToken = useCallback(() => {
        const action_type = _.get(action.value, 'related_type')
        return Object.values(CodiLinkTypes).find(
            ({value}) => value === action_type
        )?.token
    }, [action.value])

    const onCancel = () => {
        setAction({})
    }

    const type_action = _.get(action.value, 'related_type')

    const notifyChange = useCallback(
        (updateToken) => {
            if (updateToken) {
                history.push({
                    ...location,
                    state: {
                        ...(location.state ?? {}),
                        [updateToken]: Date.now(),
                    },
                })
            }
        },
        [location]
    )

    const {handleAsyncAction: createLink} = useAsyncAction({
        apiInfo: docs_createCodiLink_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            onCancel()
            successNotify(NotificationActionTypes.CREATE, t)
            const updateToken = getToken()
            notifyChange(updateToken)
        },
    })

    const {handleAsyncAction: editLink} = useAsyncAction({
        apiInfo: docs_editCodiLink_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            onCancel()
            successNotify(NotificationActionTypes.UPDATE, t)
            const updateToken = getToken()
            notifyChange(updateToken)
        },
    })

    const {handleAsyncAction: deleteLink} = useAsyncAction({
        apiInfo: docs_deleteCodiLink_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            const updateToken = getToken()
            notifyChange(updateToken)
            onCancel()
        },
    })

    const modal_content = useMemo(() => {
        let Content = NullAsDefault
        let modal_params = {}
        switch (action.type) {
            case CRUD.CREATE:
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {`${t('create docs')} ${t(type_action)}`}
                        </div>
                    ),
                    defaultValues: {
                        eff_date: item.eff_date,
                    },
                    item: item,
                    selected: current_row,
                    onSubmit: (values) => {
                        createLink(values, {id: params.owner_id, type: params.owner_type})
                    },
                }
                Content = CodiCreateLink
                break
            case CRUD.UPDATE:
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {`${t('edit docs')} ${t(type_action)}`}
                        </div>
                    ),
                    onSubmit: (values) => {
                        editLink(values, {id: action.value?.id})
                    },
                }
                Content = CodiEditLink
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                open={action.type}
                destroyOnHidden={true}
                className="custom-modal"
                title={modal_params.title}>
                <Content
                    {...params}
                    {...modal_params}
                    item={action.value}
                    onCancel={onCancel}
                    updateToken={getToken()}
                />
            </Modal>
        )
    }, [action, params, item.eff_date])

    const renderActions = useCallback(
        ({related_type}) =>
            renderIf(
                login.edit_system,
                <IoIosAddCircleOutline
                    size={17}
                    className="text-color-200 hover:text-primary cursor-pointer"
                    onClick={() => {
                        setAction({
                            type: CRUD.CREATE,
                            value: {related_type},
                        })
                    }}
                />
            ),
        [login.edit_system]
    )

    const handleAction = (action, item) => {
        if (action === CRUD.DELETE) {
            setAction({
                value: item,
            })
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete link',
                message: 'do you want to delete this link',
                onOk: () => {
                    deleteLink({}, {id: item?.id})
                },
            })
        } else {
            setAction({
                type: action,
                value: item,
            })
        }
    }

    const renderItem = useCallback(
        (item, index) => (
            <div
                key={index}
                className="create-my-timeline">
                <div
                    style={{width: '10px', marginTop: '4px'}}
                    className="flex flex-col gap-1 items-center">
                    <RiCircleFill
                        size={index === 0 ? 10 : 8}
                        style={{
                            color: index === 0 ? 'var(--color-primary)' : '#d9d9d9',
                        }}
                        className="timeline-icon"
                    />
                    <div className="timeline-tail flex-1 h-full"/>
                </div>
                {renderCodiLink({
                    renderContextMenu: !login.edit_system
                        ? NullAsDefault
                        : (item) =>
                            createContextMenu(
                                [
                                    {
                                        icon: <BsPencilSquare/>,
                                        label: <span className="font-medium">{t('edit')}</span>,
                                        key: CRUD.UPDATE,
                                    },
                                    {
                                        icon: <BsTrash/>,
                                        label: <span className="font-medium">{t('delete')}</span>,
                                        key: CRUD.DELETE,
                                    },
                                ].filter((e) => item),
                                (key) => {
                                    handleAction(key, item)
                                }
                            ),
                })(item, index)}
            </div>
        ),
        [login.edit_system]
    )
    return (
        <div
            style={style}
            className={classNames('flex flex-col', className)}>
            <div className="flex flex-col gap-3">
                {Array.from(linkTypes ?? []).map((type, index) => (
                    <CodiLinkBlock
                        key={index}
                        {...params}
                        token={type?.token}
                        title={type?.label}
                        renderItem={renderItem}
                        related_type={type?.value}
                        renderActions={renderActions}
                    />
                ))}
                {modal_content}
            </div>
        </div>
    )
}

const EnhancedCodiDocumentLinks = (props) => {
    const {item, storage} = useContext(CodiDocumentContext)
    const {selected_item} = storage || {}
    return (
        <CodiDocumentLinks
            {...props}
            item={item}
            current_row={selected_item}
            target={selected_item ?? item}
        />
    )
}

export const CodiCurrentLinks = ({item, target, current_row, ...props}) => (
    <CodiDocumentLinks
        {...props}
        {...{item, target, current_row}}
        linkTypes={[CodiLinkTypes.REFERENCE]}
    />
)

export default EnhancedCodiDocumentLinks
